import React from "react";
import MainPage from "./views/MainPage/MainPage";
import { Provider } from "react-redux";
import { store } from "./redux/Store/store";
import CustomToaster from "./Components/Toast/CustomToaster";
import Coffetti from "./Components/Coffetti/Coffetti";

function App() {
  return (
    <div className="App">
      <CustomToaster />
      <Provider store={store}>
        {/* here we use Coffeti */}
        <Coffetti />
        <MainPage />
      </Provider>
    </div>
  );
}

export default App;
